// FilterModal.jsx
import React, { useEffect, useState } from "react";
import { TfiWorld } from "react-icons/tfi";

export function FilterModal({
  open,
  onClose,
  regions = [],
  selected = "all",
  onSelect,
}) {
  const [mounted, setMounted] = useState(open);
  const [active, setActive] = useState(false);

  useEffect(() => {
    let t;
    if (open) {
      setMounted(true);
      t = setTimeout(() => setActive(true), 10);
    } else {
      setActive(false);
      t = setTimeout(() => setMounted(false), 300);
    }
    return () => clearTimeout(t);
  }, [open]);

  if (!mounted) return null;

  // id is "all" or the region id coming from the API
  const choose = (id) => {
    onSelect?.(id);
    setTimeout(() => {
      onClose?.();
    }, 700);
  };

  const btnClass = (isSelected) =>
    `flex flex-col h-[120px] items-end justify-center px-4 gap-5 rounded-xl transition-all ${
      isSelected
        ? "bg-blue-50 border-2 border-blue-500"
        : "bg-gray-50 border border-gray-200"
    }`;

  return (
    <div className="fixed inset-0 z-20 w-full h-max pt-[100px] px-[20px]">
      {/* panel sliding from top */}
      <div
        className={`flex flex-col bg-white rounded-lg pb-[20px] transform transition-all duration-300 overflow-hidden ${
          active ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
        role="dialog"
        aria-modal="true"
      >
        <div className="px-7 pt-3">
          <div className="flex items-start justify-between">
            <h3 className="text-lg font-bold px-2">News Filter</h3>
            <button
              onClick={() => onClose?.()}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
        </div>

        <div
          dir="ltr"
          className="px-6 pt-3 overflow-auto grid grid-cols-2 gap-4"
        >
          {/* All news */}
          <button
            onClick={() => choose("all")}
            className={btnClass(selected === "all")}
          >
            <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
              <TfiWorld size={20} className="text-white" />
            </div>
            <span className="font-semibold text-blue-700">All News</span>
          </button>

          {/* Regions from API */}
          {regions.map((region) => (
            <button
              key={region._id}
              onClick={() => choose(region._id)}
              className={btnClass(selected === region._id)}
            >
              <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center">
                <span className="text-white text-xs font-bold">
                  {region.code ?? region.name?.slice(0, 2)}
                </span>
              </div>

              <div className="flex flex-col items-center gap-1">
                <span className="text-sm text-gray-700">{region.name}</span>
                {/*{region.news_count != null && (*/}
                {/*    <span className="text-xs text-gray-400">*/}
                {/*        {region.news_count}*/}
                {/*    </span>*/}
                {/*)}*/}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
